@import '../../utils/control-density.css';
@import '../../utils/interaction-fill.css';
@import '../../utils/focus-ring.css';
@import '../../utils/forced-colors.css';

:host {
  display: block;
  font-family: var(--typography-font-family-ui);
  user-select: none;
}

.chart-legend__list {
  margin: 0;
  padding: 0;
  list-style: none;
}

/* Non-visual wrapper — the real box is .chart-legend__item so optional highlight/link
   affordances cover the whole row while children align to the shared grid columns. */
.chart-legend__list-item {
  display: contents;
}

:host(.chart-legend--vertical) .chart-legend__list {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) var(--dimension-size-600);
  column-gap: var(--dimension-space-075);
  row-gap: var(--dimension-space-050);
}

:host(.chart-legend--vertical.chart-legend--show-percentage) .chart-legend__list {
  grid-template-columns: auto minmax(0, 1fr) var(--dimension-size-600) var(--dimension-size-800);
}

:host(.chart-legend--vertical) .chart-legend__item {
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: subgrid;
}

:host(.chart-legend--horizontal) .chart-legend__list {
  display: flex;
  flex-wrap: wrap;
  gap: var(--dimension-space-200);
}

:host(.chart-legend--horizontal) .chart-legend__item {
  display: flex;
  gap: var(--dimension-space-100);
}

/*
 * Density: md control recipe (height / pad / radius / label inset).
 * Hover/press: `.ds-interaction-fill` (token overlay on ::after).
 */
.chart-legend__item {
  box-sizing: border-box;
  height: var(--ds-control-height, var(--dimension-size-400));
  align-items: center;
  padding: 0 var(--ds-control-padding-inline, var(--dimension-space-075));
  border-radius: var(--ds-control-radius, var(--dimension-radius-025));
  text-decoration: none;
  color: inherit;
  transition: opacity var(--effect-motion-short-2);
}

.chart-legend__item--dimmed {
  opacity: var(--effect-opacity-medium);
}

@media (prefers-reduced-motion: reduce) {
  .chart-legend__item {
    transition: none;
  }
}

.chart-legend__item--interactive {
  cursor: pointer;
}

/* Raise row content above interaction fills (positive z-index on util layers). */
.chart-legend__item > * {
  position: relative;
  z-index: 2;
}

.chart-legend__swatch-box {
  width: var(--dimension-size-250);
  height: var(--dimension-size-250);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.chart-legend__swatch {
  width: var(--dimension-space-150);
  height: var(--dimension-space-150);
  border-radius: var(--dimension-radius-025);
  flex-shrink: 0;
}

.chart-legend__label {
  min-width: 0;
}

.chart-legend__percentage {
  width: 100%;
  min-width: 0;
  text-align: right;
}

.chart-legend__value {
  width: 100%;
  text-align: right;
  min-width: 0;
}

@media (forced-colors: active) {
  .chart-legend__swatch {
    forced-color-adjust: none;
    outline: var(--dimension-stroke-width-012) solid var(--ds-forced-color-content);
  }
}
